module.exports = __webpack_public_path__ + "img/v2-redesign-analyst-preview.c381a43d.png";